import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotificationsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1050_441020)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.95599 5.21892C5.34405 5.97026 4.99853 7.05957 4.99853 8.35509V10.0021C4.99853 10.8199 4.65681 11.4992 4.29454 12.0168C3.96325 12.4902 3.55066 12.9153 3.22667 13.249C3.19947 13.277 3.17288 13.3044 3.14703 13.3311C2.84394 13.6443 2.64558 14.0695 2.64558 14.5633C2.64558 15.0624 2.99291 15.3869 3.33186 15.3869H14.3123C14.6513 15.3869 14.9986 15.0624 14.9986 14.5633C14.9986 14.0695 14.8002 13.6443 14.4971 13.3311C14.4713 13.3044 14.4447 13.277 14.4175 13.249C14.0935 12.9153 13.6809 12.4902 13.3496 12.0168C12.9873 11.4992 12.6456 10.8199 12.6456 10.0021V8.35509C12.6456 7.05957 12.3001 5.97026 11.6882 5.21893C11.0909 4.48553 10.1678 3.98398 8.82208 3.98398C7.4764 3.98398 6.55332 4.48553 5.95599 5.21892ZM4.62931 3.96572C5.60062 2.77316 7.03046 2.0835 8.82208 2.0835C10.6137 2.0835 12.0436 2.77316 13.0149 3.96572C13.9715 5.14034 14.4103 6.71171 14.4103 8.35509V10.0021C14.4103 10.2341 14.5069 10.513 14.7589 10.873C15.0004 11.2181 15.3139 11.5416 15.6602 11.8991C15.6796 11.9192 15.6992 11.9394 15.7189 11.9597C16.3221 12.5831 16.7633 13.486 16.7633 14.5633C16.7633 16.0235 15.7061 17.2873 14.3123 17.2873H3.33186C1.93814 17.2873 0.880859 16.0235 0.880859 14.5633C0.880859 13.486 1.32201 12.5831 1.92532 11.9597C1.94498 11.9394 1.96455 11.9192 1.984 11.8991C2.33031 11.5416 2.64379 11.2181 2.88528 10.873C3.13719 10.513 3.23382 10.2341 3.23382 10.0021V8.35509C3.23382 6.71171 3.67261 5.14034 4.62931 3.96572Z",
				fill: "#3C59F6"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.56581 18.3984C6.97054 18.1061 7.51863 18.2225 7.79004 18.6584C7.87775 18.7992 8.01399 18.9321 8.19716 19.0304C8.38061 19.1288 8.59652 19.1843 8.82196 19.1843C9.04749 19.1843 9.26332 19.1288 9.44676 19.0304C9.62994 18.9321 9.76617 18.7992 9.85388 18.6584C10.1253 18.2225 10.6734 18.1061 11.0782 18.3984C11.4829 18.6908 11.591 19.2811 11.3195 19.717C11.0485 20.1521 10.67 20.4974 10.2337 20.7315C9.79767 20.9654 9.31132 21.0848 8.82196 21.0848C8.33261 21.0848 7.84625 20.9654 7.41019 20.7315C6.97399 20.4974 6.59542 20.1521 6.32443 19.717C6.05301 19.2811 6.16108 18.6908 6.56581 18.3984Z",
				fill: "#3C59F6"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0352 0.542969C14.8247 0.543045 16.2393 2.04695 16.2393 3.85547C16.239 5.66378 14.8246 7.16692 13.0352 7.16699C11.2457 7.16699 9.83131 5.66382 9.83105 3.85547C9.83105 2.0469 11.2455 0.542969 13.0352 0.542969Z",
			fill: "#FF6363",
			stroke: "#F9FBFC",
			strokeWidth: 1.08579
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1050_441020",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17.6441,
				height: 19.0014,
				fill: "white",
				transform: "translate(0 2.08447)"
			})
		}) })
	]
});
export default SvgNotificationsActive;
